
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm-4.166-6.646l9.52-9.52-1.188-1.188-9.52 9.52 1.188 1.188zm7.123.246a2.648 2.648 0 002.643-2.643 2.649 2.649 0 00-2.643-2.644 2.649 2.649 0 00-2.644 2.644 2.649 2.649 0 002.644 2.643zm0-3.607c.537 0 .963.426.963.964a.956.956 0 01-.963.963.956.956 0 01-.964-.963c0-.538.426-.964.964-.964zM9.043 6.4A2.648 2.648 0 006.4 9.043c0 1.456 1.188 2.621 2.643 2.644a2.648 2.648 0 002.644-2.644A2.648 2.648 0 009.044 6.4zm0 3.607a.956.956 0 01-.963-.964c0-.537.426-.963.963-.963.538 0 .964.426.964.963a.956.956 0 01-.964.964z","fill":"#809D99"}})])
          )
        }
      }
    